import { IContactsConfig } from "@/config/contacts.config";

// Georgia-specific contacts configuration
const georgiaContactsConfig: IContactsConfig = {
  phone: "+995555395603",
  email: "info@avezor.ge",
  whatsapp: "https://wa.me/995555395603/",
  telegram: "https://t.me/avezor_ge",
  telegramBot: "https://t.me/avezorbot",
  viber: "viber://chat?number=+995555395603",
  address: {
    en: "Rustaveli Ave 12, Tbilisi",
    el: "Rustaveli Ave 12, Tbilisi",
    ru: "Проспект Руставели 12, Тбилиси",
  },
  location: {
    city: "Tbilisi",
    country: "Georgia",
  },
};

export default georgiaContactsConfig;
